module.exports = __webpack_public_path__ + "static/media/funitures7.e127b5f3.svg";